import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { useRouter } from '../../hooks/useRouter.js';
import { Icon } from '../../ui-kit/Icon/Icon.js';
import { Logo } from '../../ui-kit/Logo/Logo.js';
import { InternetBankButton } from './InternetBankButton.js';
export const HeaderTop = JSX(({ bgColor, logo, alwaysShowLogo, internetBankButton, version, backwardButton }) => {
    const router = useRouter();
    const isRootLocation = router.pathname === '/';
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { dataFooter, dataHeader, ...logoProps } = logo ?? {};
    const onClick = useCallback(() => {
        router.back();
    }, [router]);
    return (_jsxs("div", { className: "flex items-center justify-between w-full", children: [alwaysShowLogo || isRootLocation ? (_jsx("div", { children: _jsx(Logo, { className: "my-2xs", bgColor: bgColor, logo: logoProps, data: dataHeader, showTitle: false }) })) : (renderBackButton(onClick, backwardButton)), _jsx(InternetBankButton, { version: version, ...internetBankButton })] }));
});
const renderBackButton = (onClick, text) => text ? (_jsxs("button", { className: "flex items-center text-l my-2xs", onClick: onClick, type: "button", "aria-label": "\u041A\u043D\u043E\u043F\u043A\u0430 \u043D\u0430\u0437\u0430\u0434", children: [_jsx(Icon, { name: "ChevronLeftIcon", iconVersion: "black", width: "24", height: "24" }), text] })) : null;
//# sourceMappingURL=HeaderTop.js.map